import { ComponentProps } from 'react';
import cx from 'classnames';

import Icon from '../Icon';

import styles from './SearchInput.module.css';

import { ReactComponent as SearchSvg } from '../../../../icons/src/lib/search.svg';
import Box, { BoxStyleProps, extractBoxStyleProps } from '../Box';

export interface SearchInputProps
  extends ComponentProps<'input'>,
    BoxStyleProps {
  className?: string;
}

export default function SearchInput({
  className,
  ...otherProps
}: SearchInputProps): JSX.Element {
  const [boxStyleProps, inputProps] = extractBoxStyleProps(otherProps);
  return (
    <Box className={cx(styles['base'], className)} {...boxStyleProps}>
      <Icon className={styles['left-icon']} component={<SearchSvg />} />
      <input className={styles['input']} {...inputProps} />
    </Box>
  );
}
